<template>
  <div class="empty-cart">
    <p class="empty-cart__text">{{ $t('minicart.empty') }}</p>
    <a
      :href="homepageUrl + '/explore'"
      class="empty-cart__btn"
      @click="$store.dispatch('nav/setAdditionalNav', '')"
      >{{ $t('minicart.shop_all') }}
    </a>
    <a :href="homepageUrl + '/explore/mens'" class="empty-cart__btn">
      {{ $t('minicart.shop_mens') }}
    </a>
    <a
      :href="homepageUrl + '/explore/womens'"
      class="empty-cart__btn"
      @click="$store.dispatch('nav/setAdditionalNav', '')"
      >{{ $t('minicart.shop_womens') }}
    </a>
    <a
      :href="homepageUrl + '/shoe-finder'"
      class="empty-cart__btn"
      @click="$store.dispatch('nav/setAdditionalNav', '')"
    >
      <span class="icon-shoe-finder"></span>
      {{ $t('minicart.shop_shoefinder') }}
    </a>
  </div>
</template>

<script>
export default {
  name: 'EmptyCart',

  props: {
    homepageUrl: {
      type: String,
      required: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.empty-cart {
  &__text {
    display: block;
    margin: 14px 0 28px;

    @media ($mq-larger) {
      margin: 10px 0 44px;
    }
  }

  &__btn {
    display: block;
    margin-top: 16px;
    padding: 22px 0 20px;
    text-align: center;
    color: $color-grey-dark-2;
    background-color: $color-grey-light-4;
    transition: background-color $transition-time;

    @media ($mq-larger) {
      margin-top: 26px;
    }

    .icon-shoe-finder {
      position: relative;
      top: -1px;
      font-size: $font-size-large;

      &:before {
        color: $color-grey-dark-2;
      }
    }

    &:hover {
      background-color: $color-grey-light-1;
    }
  }
}
</style>
